const cards = [
  {
    title: "Tool Abuse",
    body: "Agents connected to APIs, CRMs, support systems, or internal tools can be manipulated into taking unintended or unauthorized actions.",
  },
  {
    title: "Over-Permissioned Agents",
    body: "Agents often inherit broad access to data, systems, or workflows without clear boundaries, role controls, or approval gates.",
  },
  {
    title: "Indirect Prompt Injection",
    body: "Agents that retrieve emails, documents, tickets, web pages, or knowledge-base content can be manipulated through untrusted inputs.",
  },
  {
    title: "Data Leakage",
    body: "Agents can expose sensitive information through retrieval, summarization, cross-user context, weak authorization, or poorly scoped tool access.",
  },
  {
    title: "Unsafe Automation",
    body: "Agents trigger workflow actions before the business has validated approvals, escalation paths, rollback, monitoring, or accountability.",
  },
  {
    title: "Missing Approval, Logging & Rollback",
    body: "Without approval gates, full audit logs, and tested rollback paths, there is no evidence the agent operated within intended boundaries.",
  },
];

export default function ArqAgenticRisk() {
  return (
    <section id="agentic-risk" className="bg-arq-bg py-20 md:py-[120px] px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center max-w-[860px] mx-auto mb-16">
          <div className="arq-label mb-6">Agentic AI Risk</div>
          <h2
            className="font-display font-semibold text-arq-text mb-6"
            style={{ fontSize: "clamp(28px, 4vw, 40px)", lineHeight: 1.2 }}
          >
            AI Agents Expand What Can Be Exposed.
          </h2>
          <div className="space-y-4 text-arq-muted text-[17px] leading-[1.75] text-left">
            <p>
              AI agents do not just generate outputs. They can retrieve data, use tools, call APIs,
              update records, trigger workflows, and influence operational decisions.
            </p>
            <p className="text-arq-text/90">That changes the risk profile.</p>
            <p>
              ArqeraAI evaluates what agents can access, what they can do, who can influence them,
              where controls are missing, and what evidence exists to prove the risk has been
              reduced.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((c) => (
            <div key={c.title} className="arq-card p-7">
              <h3 className="font-display text-[18px] font-semibold text-arq-text mb-3">
                {c.title}
              </h3>
              <p className="text-arq-muted text-[14.5px] leading-[1.7]">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
